<script setup lang="ts">
import { InfoCircle } from "@iconoir/vue";
import { computed, useTemplateRef } from "vue";

const { id } = defineProps<{ id: string }>();

const tooltipPopover = useTemplateRef("tooltip-popover");

const tooltipAnchor = computed(() => `--${id}-anchor`);

// use 'interestfor' html attribute as soon as it's widely available
// see also https://developer.mozilla.org/en-US/docs/Web/API/Popover_API/Using_interest_invokers
const showPopover = () => {
  tooltipPopover.value?.showPopover();
};

const hidePopover = () => {
  tooltipPopover.value?.hidePopover();
};
</script>

<template>
  <button
    v-bind="{ popovertarget: id }"
    type="button"
    class="tooltip-button"
    @mouseenter="showPopover"
    @mouseleave="hidePopover"
    @focus="showPopover"
    @blur="hidePopover"
  >
    <InfoCircle />
  </button>
  <div
    :id="id"
    ref="tooltip-popover"
    v-bind="{ popover: 'hint' }"
    class="tooltip-popover"
  >
    <slot />
  </div>
</template>

<style scoped>
.tooltip-button {
  background: none;
  border: none;
  color: var(--text-color-muted);
  anchor-name: v-bind(tooltipAnchor);
}

.tooltip-popover {
  background-color: var(--bg-color-tooltip);
  border-style: none;
  border-radius: var(--border-radius-tooltip);
  box-shadow: var(--shadow);
  padding: var(--padding-tooltip);
  max-inline-size: var(--inline-size-md);
  position: absolute;
  position-anchor: v-bind(tooltipAnchor);
  position-area: end;
  position-try-fallbacks:
    end start,
    start end,
    start;
}
</style>
